import { Address } from './address'
import { Coordiate } from './corodinate'
import { HoursOfOperation } from "../hours-of-operation";
import {EVStationBranch} from "../../entity/corporate/corporateDetails";


export class EVCStationStatus {
    id: number
    name: string

    constructor(id: number, name: string) {
        this.id = id
        this.name = name
    }
}
export class EVCStationCategory {
    id: number
    name: string

    constructor(id: number, name: string) {
        this.id = id
        this.name = name
    }
}

export class EVCStationThirdPartyStatus{
    id: number
    name: string
    constructor(id: number, name: string) {
        this.id = id
        this.name = name
    }
}

export class EVCStationThirdPartyList{
    id: number
    name: string
    description: string
    imgUrl: string
    constructor(id: number, name: string, description: string, imgUrl: string) {
        this.id = id
        this.name = name
        this.description = description
        this.imgUrl = imgUrl
    }
}

export class Distance {
    value?: number
    unit?: string
    description?: string

    constructor(value?: number, unit?: string, description?: string) {
        this.value = value
        this.unit = unit
        this.description = description
    }
}

export class EVCStation {
    id: number
    name: string    
    effectiveOn: Date  
    effectiveTill: Date
    status: EVCStationStatus
    stationCategory: EVCStationCategory
    // thirdPartyStatus: EVCStationThirdPartyStatus
    thirdPartyInfo?: EVCStationThirdPartyList 
    address?: Address
    landline?: string
    mobile?: string
    email?: string
    coordinate?: Coordiate
    hoursOfOperations?: HoursOfOperation[]
    distributionNode?: string
    distance?: Distance
    rating?: string
    branch?: EVStationBranch

    constructor(id: number, name: string, effectiveOn: Date, effectiveTill: Date, status: EVCStationStatus, stationCategory: EVCStationCategory , thirdPartyInfo?: EVCStationThirdPartyList, address?: Address, landline?: string, mobile?: string, email?: string, coordinate?: Coordiate, hoursOfOperations?: HoursOfOperation[], distributionNode?: string, distance?: Distance, rating?: string, branch?: EVStationBranch) {
        this.id = id
        this.name = name        
        this.effectiveOn = effectiveOn
        this.effectiveTill = effectiveTill
        this.status = status
        this.stationCategory = stationCategory
        // this.thirdPartyStatus = thirdPartyStatus
        this.thirdPartyInfo = thirdPartyInfo
        this.address = address
        this.landline = landline
        this.mobile = mobile
        this.email = email
        this.coordinate = coordinate
        this.hoursOfOperations = hoursOfOperations
        this.distributionNode = distributionNode
        this.distance = distance
        this.rating = rating
        this.branch = branch
    }
}

export class EVCStationHoliday {
    date: Date
    reason: string
    timing: string

    constructor(date: Date, reason: string, timing: string) {
        this.date = date
        this.reason = reason
        this.timing = timing
    }
}

export class EVCStationImage {
    file: string
   

    constructor(file: string) {
        this.file = file
    }
}